// Function to clean citation markers from text
export const cleanCitationMarkers = (text: string): string => {
  // Check if text contains citation markers
  const hasCitations = /【\d+:\d+†[^】]+】/g.test(text);

  // if (!hasCitations) {
  //   return text;
  // }

  // Remove citation markers like 【38:0†source】
  return text.replace(/【\d+:\d+†[^】]+】/g, "");
};